import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import GalleryJobCard from "./GalleryJobCard";
import { api } from "../lib/api";

const HOME_LIMIT = 4;

const GallerySection = () => {
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        api.get("/gallery").then(({ data }) => setJobs(data)).catch(() => setJobs([]));
    }, []);

    if (jobs.length === 0) return null;

    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="gallery-section">
            <Reveal className="mb-14 flex flex-col md:flex-row md:items-end justify-between gap-6">
                <div>
                    <Eyebrow className="mb-4">Real jobs</Eyebrow>
                    <h2 className="font-display font-black uppercase text-brand-cream text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
                        Before. <span className="text-brand-amber">After.</span>
                    </h2>
                </div>
                <p className="max-w-sm text-brand-sage text-base leading-relaxed">
                    Drag the handle to see what a stump looks like when we leave.
                    Every photo is from a job in our 30-mile service area.
                </p>
            </Reveal>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                {jobs.slice(0, HOME_LIMIT).map((job, i) => (
                    <GalleryJobCard key={job.id} job={job} index={i} />
                ))}
            </div>

            <Reveal className="mt-12 flex justify-center">
                <Link
                    to="/gallery"
                    data-testid="gallery-see-all-link"
                    className="group inline-flex items-center gap-3 border border-brand-cream/30 text-brand-cream font-semibold text-base px-8 py-4 rounded-full hover:border-brand-amber hover:text-brand-amber transition-all duration-300"
                >
                    See all {jobs.length} job{jobs.length === 1 ? "" : "s"}
                    <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
            </Reveal>
        </section>
    );
};

export default GallerySection;
